import { render, staticRenderFns } from "./PasswordManagementFooter.vue?vue&type=template&id=9120ad3c&scoped=true"
import script from "./PasswordManagementFooter.vue?vue&type=script&lang=js"
export * from "./PasswordManagementFooter.vue?vue&type=script&lang=js"
import style0 from "./PasswordManagementFooter.vue?vue&type=style&index=0&id=9120ad3c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9120ad3c",
  null
  
)

export default component.exports